import axios from 'axios'

export const loginUser = (pk: string) => {
  return axios.post('/api/v1/test_login', { pk }).then((res) => res.data)
}
